/**
 * Sprint 103 — one download path for every DK CSV export.
 *
 * A player our pool spells differently from DK's entry file used to kill the
 * whole download at 10am on a Sunday. The backend now falls back to the
 * slate's own draftable ids, and anything still unresolved comes back as a
 * recoverable 422 (`DK_UNMAPPED_PLAYERS`) — so we ask, then retry with
 * ?force=true instead of leaving the user stuck.
 */
import { toast } from "sonner";

const save = async (res, filename) => {
  const url = URL.createObjectURL(await res.blob());
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};

export async function downloadDkCsv(url, filename, { onForced } = {}) {
  const res = await fetch(url, { method: "GET", credentials: "include" });
  if (res.ok) {
    await save(res, filename);
    return { ok: true };
  }
  const err = await res.json().catch(() => ({}));
  const detail = err?.detail;
  const code = typeof detail === "object" ? detail?.code : null;
  const message = typeof detail === "string" ? detail : detail?.message || "Export failed";

  if (code === "DK_UNMAPPED_PLAYERS") {
    const go = window.confirm(`${message}\n\nDownload anyway?`);
    if (!go) return { ok: false, message };
    const sep = url.includes("?") ? "&" : "?";
    const forced = await fetch(`${url}${sep}force=true`, { method: "GET", credentials: "include" });
    if (!forced.ok) {
      const e2 = await forced.json().catch(() => ({}));
      const m2 = typeof e2?.detail === "string" ? e2.detail : e2?.detail?.message || "Export failed";
      throw new Error(m2);
    }
    await save(forced, filename);
    if (typeof onForced === "function") onForced(message);
    else toast.warning("Downloaded with unmatched players left as names — check DK accepts it");
    return { ok: true, forced: true };
  }
  throw new Error(message);
}
